import youtubePlayer from 'youtube-player';

let $document = $(document);
let $videoBlock = $('.video');

function initForm() {
	let $form = $videoBlock.find('.video__group-form');
	let $checkbox = $videoBlock.find('.video__checkbox-item');

	$form.on('submit', (e) => {
		let $currentForm = $(e.currentTarget);

		$currentForm.addClass('ajax-loading');

		$.ajax({
			type: 'POST',
			url: '/ajax/form_mail.php',
			data: $currentForm.serializeArray(),
			dataType: 'json',
			success(data) {
				$currentForm
					.removeClass('ajax-loading')
					.get(0)
					.reset();

				if (data.success) {
					let $formFooter = $currentForm.find('.video__footer-form');
					let $message = $('.message-wrap2');

					$document.trigger('email-form-succes');
					$currentForm.hide();
					$formFooter.hide();

					$message.fadeIn(() => {
						setTimeout(() => {
							$message.hide();
							$currentForm.fadeIn();
							$formFooter.fadeIn();
						}, 4000);
					});
				}
			},
			error() {
				$currentForm.removeClass('ajax-loading');
			},
		});

		return false;
	});

	$checkbox.on('change', (e) => {
		let $submitButton = $(e.currentTarget).closest('.video__form').find('.video__button-form');

		if (e.currentTarget.checked) {
			$submitButton
				.removeClass('is-disabled')
				.prop('disabled', false);
		} else {
			$submitButton
				.addClass('is-disabled')
				.prop('disabled', true);
		}
	});
}

function initVideo(currentPage) {
	let $video = currentPage.find('.video');
	let source = $video.data('video');
	let name = $video.data('name');

	if (!source) {
		return;
	}

	let videoTag = '<div class="video__player"></div>';

	$video
		.addClass('video--youtube')
		.empty()
		.append(videoTag);

	let videoIsPlaying = false;
	let player30Interval = null;
	let video = $video.find('.video__player').get(0);
	let player = youtubePlayer(video, {
		width: '100%',
		height: '100%',
		videoId: source.split('/embed/')[1].split('?')[0],
		playerVars: {
			playsinline: 1,
			rel: 0,
		},
	});

	player.on('stateChange', (e) => {
		if (e.data === 0) {
			videoIsPlaying = false;

			$document.trigger('video-finish', [name]);

			clearInterval(player30Interval);
		} else if (e.data === 1 && !videoIsPlaying) {
			videoIsPlaying = true;

			$document.trigger('video-play', [name]);

			clearInterval(player30Interval);

			player30Interval = setInterval(() => {
				$document.trigger('video-30sec', [name]);
			}, 30000);
		} else if (e.data === 2) {
			videoIsPlaying = false;

			clearInterval(player30Interval);
		}
	});
}

initForm();

export default {
	initVideo,
};
